import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import IconReport from '../../../../images/icons/misc/ui-stats.svg';
import IconArrowLeft from '../../../../images/icons/white/icon-arrow-left.svg';

import styles from './Header.module.scss';

function Header({ t = (v) => v }) {
  return (
    <div className={styles.header}>
      <div>
        <IconReport className={styles.icon} />
        <span>{t('Reports')}</span>
      </div>
      <div>
        <Link to={'/account'} className={styles.backButton}>
          <IconArrowLeft className={styles.arrow} />
          <span>{t('Back to My Account')}</span>
        </Link>
      </div>
    </div>
  );
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
